<template>
  <div class="app-container">
    <OrderSearch ref="OrderSearch" :listQuery.sync="listQuery" :dealerOptions="dealerOptions"
      :importSources="importSources" :customerFromSources="customerFromSources" :seriesOptions="seriesOptions"
      :mainOrderStatusDics="mainOrderStatusDics" :orderBusinessType="orderBusinessType" @do-search="doSearch"
      @do-reset="doReset" @do-export="doExport" />
    <el-table :data="list" stripe v-loading="listLoading" class="page-list">
      <el-table-column v-for="column in tableColumns" :key="column.prop" :prop="column.prop"
        :align="column.align || 'left'" :label="column.label" :width="column.width" :min-width="column.minWidth"
        :fixed="column.fixed">
        <template slot-scope="{row}">
          <slot :name="column.prop" :row="row">
            <template v-if="column.prop === 'operation'">
              <el-button size="mini" @click="showTimelineDialog(row)">轨迹</el-button>
            </template>
            <template v-else>
              {{ formatterColumnData(row, column) }}
            </template>
          </slot>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

    <!-- 轨迹 -->
    <el-dialog :title="viewTitle" :visible.sync="timelineDialog" width="550px">
      <el-table :data="timelines" border fit highlight-current-row style="width: 100%" max-height="350">
        <el-table-column align="left" label="时间" width="150">
          <template slot-scope="scope">
            <span>{{
              scope.row.createdAt | parseTime("{y}-{m}-{d} {h}:{i}")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="结果">
          <template slot-scope="scope">
            <span>
              <el-row v-if="scope.row.createUser">
                <el-col :span="5">处理人员:</el-col>
                <el-col :span="19">{{ scope.row.createUser }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="5">处理结果:</el-col>
                <el-col :span="19">{{ formatLabel(scope.row.orderStatus, orderStatusDics) }}</el-col>
              </el-row>
              <el-row v-if="scope.row.content != ''">
                <el-col :span="5">内容:</el-col>
                <el-col :span="19">
                  <span v-html="scope.row.content.replaceAll('\n', '<br/>')"></span>
                </el-col>
              </el-row>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="timelineDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OrderSearch from './components/OrderSearch.vue'
import { carLicenseTypeList, clueTypeList, CONSTANT_1, CONSTANT_2, customerTypeList, formatDate } from './js/form-options'
import { parseTime, downFile } from '@/utils/index'
import dayjs from 'dayjs';

const initListQuery = {
  page: 1,
  limit: 10,
  dateRange1: [dayjs(new Date().getTime() - 3600 * 1000 * 24 * 30).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
  dateRange2: null,
  dateRange3: null,
  fromSources: [],
  onlineSource: [],
  key: "",
  bigOrderNo: "",
  fromType: null,
  dealerCode: [],
  specIds: [],
  orderStatus: [],
  orderType: null,
  customerId: null,
  clueId: null,
}
export default {
  name: "SalesOrderList",
  components: { OrderSearch },
  data() {
    return {
      customerFromSources: [],
      customerFromSourcesHist: [],
      importSources: [],
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        ...initListQuery
      },
      tableColumns: [
        { prop: 'createdAt', label: '订单创建时间', minWidth: 120, formatter: (row, prop) => parseTime(row[prop], "{y}-{m}-{d} {h}:{i}") },
        { prop: 'bigOrderNo', label: '主订单号', width: 120 },
        { prop: 'orderStatus', label: '主订单状态', width: 100, formatter: (row, prop) => this.formatLabel(row[prop], this.orderStatusDics) },
        { prop: 'customerName', label: '客户名称', width: 100, formatter: (row, prop) => row.customerType === CONSTANT_1 ? row.customerName : row.companyName },
        { prop: 'customerPhone', label: '客户手机号', width: 100 },
        { prop: 'clueId', label: '线索ID', width: 80 },
        { prop: 'customerId', label: '客户ID', width: 80 },
        { prop: 'sourceType', label: '线索类型', width: 100, formatter: (row, prop) => this.formatLabel(row[prop], clueTypeList, { name: 'name', value: 'value' }) },
        { prop: 'subOrderId', label: '子订单号', width: 130 },
        { prop: 'subOrderOrderStatus', label: '子订单状态', minWidth: 120, formatter: (row, prop) => this.formatLabel(row[prop], this.orderStatusDics) },
        { prop: 'dealerCode', label: '经销商编码', width: 120 },
        { prop: 'dealerName', label: '经销商名称', minWidth: 120 },
        { prop: 'customerType', label: '客户类型', width: 100, formatter: (row, prop) => this.formatLabel(row[prop], customerTypeList, { name: 'name', value: 'value' }) },
        {
          prop: 'customerSource', label: '客户来源', minWidth: 120, formatter: (row, prop) => {
            return `${this.formatLabel(row[prop], clueTypeList, { name: 'name', value: 'value' })}:${Number(row[prop]) === CONSTANT_1 ? row.sourceChannel : this.formatLabel(row.customerChannel, this.customerFromSourcesHist)}`
          }
        },
        { prop: 'businessType', label: '业务类型', width: 120, formatter: (row, prop) => this.formatLabel(row[prop], this.orderBusinessType) },
        { prop: 'contractNo', label: '合同编码', width: 100 },
        { prop: 'carLicenseType', label: '上牌方式', width: 100, formatter: (row, prop) => this.formatLabel(row[prop], carLicenseTypeList, { name: 'name', value: 'value' }) },
        { prop: 'carLicenseCity', label: '上牌城市', minWidth: 120, formatter: (row, prop) => row[prop] ? row[prop].replace(',', '/') : '' },
        { prop: 'ownerName', label: '销售顾问', width: 80 },
        { prop: 'seriesName', label: '订购车系', width: 120 },
        { prop: 'specName', label: '订购车型', width: 120 },
        { prop: 'carExternalColor', label: '订购颜色', width: 80 },
        { prop: 'number', label: '订车数量', width: 80 },
        { prop: 'orderDeliverTime', label: '实际交车时间', minWidth: 120, formatter: (row, prop) => parseTime(row[prop], "{y}-{m}-{d} {h}:{i}") },
        { prop: 'operation', label: '操作', fixed: 'right' },
      ],
      dealerOptions: [],
      seriesOptions: [],
      orderStatusDics: [],
      mainOrderStatusDics: [],
      orderBusinessType: [],
      timelineDialog: false,
      timelines: [],
      viewTitle: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  activated() {
    if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
      this.doReset();
      this.$route.meta.redraw = false;
    }
    if (
      this.$route.meta.hasOwnProperty("refresh") &&
      this.$route.meta.refresh
    ) {
      this.getList();
      this.$route.meta.refresh = false;
    }
  },
  created() {
    this.retrieveSystemData();
    this.retrieveDealerOptions();
    this.retrieveSeriesOptions();
    this.doReset();
  },
  methods: {
    formatterColumnData(row, column) {
      if (typeof column.formatter === 'function') {
        return column.formatter(row, column.prop)
      }
      return row[column.prop]
    },
    formatLabel(val, list, { name = 'dataDisplay', value = 'dataValue' } = {}) {
      const row = list.find(item => item[value] === Number(val)) || {}
      return row[name] || ''
    },
    retrieveSystemData() {
      this.$httpAuth.post("/v1/baseRpc/info", {}).then((response) => {
        const { customerLevels = [], customerFromSources = [], customerFromSourcesHist = [], importSources = [], customerOrderStatus, mainOrderStatusDics = [], orderBusinessType = [] } = response.data
        this.customerLevels = customerLevels;
        this.customerFromSources = customerFromSources;
        this.customerFromSourcesHist = customerFromSourcesHist;
        this.importSources = importSources;
        this.orderStatusDics = customerOrderStatus;
        this.mainOrderStatusDics = mainOrderStatusDics;
        this.orderBusinessType = orderBusinessType;
      });
    },
    retrieveDealerOptions() {
      this.$httpAuth
        .post("/v1/backendDealerRpc/jsonTree", {})
        .then((response) => {
          this.dealerOptions = response.data?.data || [];
          this.dealerOptions.unshift({
            label: "全部",
            level: 1,
            value: ""
          });
        });
    },
    retrieveSeriesOptions() {
      this.$httpAuth
        .post("/v1/backendVehicleRpc/validSeriesList", {})
        .then((response) => {
          this.seriesOptions = response.data.records;
        });
    },
    doReset() {
      this.listQuery = {
        ...initListQuery
      };
      this.doSearch();
    },
    doSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.list = [];
      this.listLoading = true;
      const { page, limit } = this.listQuery
      const params = this.getParams();
      this.$httpAuth
        .post("/v1/appCustomerOrderService/backendSearch", {
          pageId: page,
          pageSize: limit,
          ...params
        })
        .then((response) => {
          this.listLoading = false;
          this.list = response.data.data;
          this.total = response.data.total;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    getParams() {
      const [dealerSalesCenter, dealerBigArea, dealerProvince, dealerCity, dealerCode] = this.listQuery.dealerCode
      if (this.listQuery.fromType === CONSTANT_1) {
        this.listQuery.fromSources = '';
      } else if (this.listQuery.fromType === CONSTANT_2) {
        this.listQuery.onlineSource = [];
      } else {
        this.listQuery.fromSources = '';
        this.listQuery.onlineSource = [];
      }
      const { key, bigOrderNo, dateRange1, dateRange2, dateRange3, fromType, fromSources, onlineSource, orderType, orderStatus, specIds, customerId, clueId } = this.listQuery
      const { dateStart: dateStart1, dateEnd: dateEnd1 } = formatDate(dateRange1)
      const { dateStart: dateStart2, dateEnd: dateEnd2 } = formatDate(dateRange2)
      const { dateStart: dateStart3, dateEnd: dateEnd3 } = formatDate(dateRange3)

      return {
        dealerCode,
        dealerBigArea,
        dealerSalesCenter,
        dealerProvince,
        dealerCity,
        customerInfo: key,
        bigOrderNo,
        createdDate: {
          start: dateStart1,
          end: dateEnd1
        },
        clueSource: fromType,
        fromSources: fromSources.toString(),
        onlineSources: onlineSource,
        businessType: orderType || null,
        customerId: customerId || null,
        clueId: clueId || null,
        orderStatus: orderStatus,
        specIds: specIds.length > 0 ? specIds.map((item) => item[1]).join(",") : "",
        reviewDate: {
          start: dateStart2,
          end: dateEnd2
        },
        orderDeliverTime: {
          start: dateStart3,
          end: dateEnd3
        },
      }
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    showTimelineDialog(row) {
      this.timelineDialog = true;
      this.viewTitle = row.customerName + " - " + row.customerPhone;
      this.getOrderTimeline(row)
    },
    getOrderTimeline({ id, dealerId }) {
      this.$httpAuth
        .post("/v1/appCustomerOrderService/OrderTimeLine", {
          orderId: String(id),
          dealerId
        })
        .then((res) => {
          this.timelines = res.data
        })
        .catch(() => {
        });
    },
    doExport() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const params = this.getParams();

      this.$httpAuth
        .post("/v1/appCustomerOrderService/orderExport", {
          ...params,
          isExport: 1,
        })
        .then((res) => {
          if (res.data.success) {
            setTimeout(() => {
              loading.close()
              this.$message({
                message: '导出任务已产生，请到 平台管理-导出任务 中查看',
                type: 'success',
              })
            }, 1000)
          } else {
            loading.close()
            this.$message({
              message: res.message || res.msg || '导出失败',
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close();
        });
    }
  }
};
</script>
